import type { FC } from 'react';
import React from 'react';
import { Flex, Body, Col, FlexRow } from '@edreamsodigeo/prisma-design-system';
import { createFeature } from '@edreamsodigeo/frontend-core';

import { RAILS_COMMERCIAL_CARRIERS } from '@/versionedComponents';
import { CarrierLogo } from '@/components/FlightSummary/Carrier/CarrierLogo';
import type { CarrierLineProps } from '@/components/FlightSummary/MapItinerary/types';

const SEPARATOR = '·';
const typeText = 'base';

const CarrierLineBase: FC<CarrierLineProps> = ({
  carrierId,
  carrierName,
  commercialBrand,
  flightCode,
  withCommercialBrand,
}) => {
  const showCommercialBrand =
    withCommercialBrand && commercialBrand && carrierId === '4R';
  const carrierIdShow = showCommercialBrand ? commercialBrand.id : carrierId;
  const carrierNameShow = showCommercialBrand
    ? commercialBrand.name
    : carrierName;
  return (
    <FlexRow
      data-testid="CarrierLine"
      flexWrap="wrap"
      pb="1x_small"
      alignItems="start"
      gap="1"
    >
      <Col>
        <CarrierLogo
          id={carrierIdShow}
          imageSize="medium"
          name={carrierIdShow}
        />
      </Col>
      <Col>
        <Body type={typeText} color="neutral.100">
          {carrierNameShow}
        </Body>
      </Col>
      <Col>
        <Flex justifyContent="center">
          <Body type={typeText} color="neutral.100">
            {SEPARATOR}
          </Body>
        </Flex>
      </Col>
      <Col>
        <Body type={typeText} color="neutral.80">
          {flightCode}
        </Body>
      </Col>
    </FlexRow>
  );
};

const CarrierLineDefault: FC<CarrierLineProps> = (props) => (
  <CarrierLineBase {...props} />
);

const CarrierLineCommercialBrand: FC<CarrierLineProps> = (props) => (
  <CarrierLineBase {...props} withCommercialBrand />
);

const CarrierLine = createFeature({
  name: RAILS_COMMERCIAL_CARRIERS,
  variations: [CarrierLineDefault, CarrierLineCommercialBrand],
  version: 1,
});

export default CarrierLine;
